const pattern = /---uniform-setting-locale=(\w+)/;

export const getCurrentLanguage = () => {
    const [, lang] = document.cookie.match(pattern) || [];
    if (!lang) {
        const host = window.location.host || '';
        if (host.indexOf('.zhihuiya.') > -1) {
            return 'cn';
        } else if (host.indexOf('.patsnap.') > -1) {
            return 'en';
        }
    }
    return lang || 'en';
};

export function checkJpEnv() {
    try {
        const url = new URL(window.location.href);
        // ?mock_region=jp/us 方便调试。兼容 hash 路由，同时检查正常参数和 hash 后的参数
        const mockRegion = url.searchParams.get('mock_region') ||
                           new URLSearchParams(url.hash.split('?')[1]).get('mock_region');

        if (mockRegion === 'jp') return true;
        if (!!mockRegion && mockRegion !== 'jp') return false;

        // 1. 浏览器语言是否为日语
        const isBrowserJapanese = navigator.language.toLowerCase().startsWith('ja');

        // 2. 产品内语言是否为日语
        const isProductJapanese = getCurrentLanguage() === 'jp';

        // 3. 时区是否为 GMT+9
        // getTimezoneOffset() 返回 UTC - 本地时间（分钟），东区为负数
        const offset = new Date().getTimezoneOffset();
        const isAsiaTimezone = offset === -540; // -540 = GMT+9
        return (isBrowserJapanese || isProductJapanese) && isAsiaTimezone;
    } catch (error) {
        console.log(error);
        return false;
    }
}
